
<div class="view-wrapper-register-merchant">
  <div class="form-container">

  <form [formGroup]="documentForm">
    <dx-box direction="col" width="100%" [height]="150">
      <dxi-item class="rect demo-dark header" [ratio]="1" height="100" style="font-weight: bold;"> Individual Documents </dxi-item>
      <dxi-item [ratio]="2" [baseSize]="0">
        
        <!-- Drop Copy Of RSA ID -->
        <dx-box direction="row" width="75%" [height]="150">
          <dxi-item class="rect demo-dark" [baseSize]="30"> 
            <dx-check-box
            [(value)]="copyOfRsaId_checkBoxValue"
            hint="File has been Uploaded"></dx-check-box>
          </dxi-item>
          <dxi-item class="rect demo-light" [baseSize]="210"><div><small>Copy of RSA ID Passport</small></div></dxi-item>
          <dxi-item class="rect demo-dark" [baseSize]="350">
            
            <div #copyOfRsaId_dropzone_external id="copyOfRsaId-UploadArea" class="flex-box uploadArea" [ngClass]="iscopyOfRsaIdDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']">
                <img id="copyOfRsaId-dropzone-image" class="Dropzone-Image" [src]="copyOfRsaIdimageSource" *ngIf="copyOfRsaIdimageSource" alt="" />
                <div id="copyOfRsaId-dropzone-text" class="flex-box uploadArea" *ngIf="copyOfRsaIdtextVisible">
                  <span>upload</span>
                </div>
              <dx-progress-bar
                #copyOfRsaId_uploadProgress
                [min]="0"
                [max]="100"
                width="100%"
                [showStatus]="true"
                [statusFormat]="statusFormat"
                [visible]="copyOfRsaIdprogressVisible"
                [value]="copyOfRsaIdprogressValue"
              ></dx-progress-bar>
            </div>
            <dx-file-uploader
                #copyOfRsaId_fileUploader
               id="copyOfRsaId-fileSelector"
               [multiple]="true"
               [visible]="false"
               [uploadCustomData]="{ KeyCloakUserId:usrKeyCloakId, MerchantId : merchantId, DocumentType: documentTypes.CopyOfRSAID}"
               uploadMode="instantly"
               uploadUrl="{{FileUploadUrl}}"
               (onDropZoneEnter)="onDropZoneEnter($event)"
               (onDropZoneLeave)="onDropZoneLeave($event)"
               (onUploaded)="onUploaded($event)"
               (onProgress)="onProgress($event)"
               (onUploadStarted)="onUploadStarted($event)">
            </dx-file-uploader>
            <!-- file Upload Column -->
          </dxi-item>
        </dx-box>
      </dxi-item>

      <dxi-item [ratio]="2" [baseSize]="0">
        <!-- Physical Address Confirmation Letter -->
        <dx-box direction="row" width="100%" [height]="150">
          <dxi-item class="rect demo-dark" [baseSize]="30"> 
            <dx-check-box
            [(value)]="physicalAddress_checkBoxValue"
            hint="File has been Uploaded"
            ></dx-check-box>
          </dxi-item>
          <dxi-item class="rect demo-light" [baseSize]="210"> <div><small>Physical Address Confirmation via Utility Bill / Statement</small></div> </dxi-item>
          <dxi-item class="rect demo-dark" [baseSize]="350">
            
            <div #physicalAddress_dropzone_external id="physicalAddress-UploadArea" class="flex-box uploadArea" [ngClass]="isphysicalAddressDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']">
                <img id="physicalAddress-dropzone-image" class="Dropzone-Image" [src]="physicalAddressimageSource" *ngIf="physicalAddressimageSource" alt="" />
                <div id="physicalAddress-dropzone-text" class="flex-box uploadArea" *ngIf="physicalAddresstextVisible">
                  <span>upload</span>
                </div>
              <dx-progress-bar
                #physicalAddress_uploadProgress

                [min]="0"
                [max]="100"
                width="100%"
                [showStatus]="true"
                [statusFormat]="statusFormat"
                [visible]="physicalAddressprogressVisible"
                [value]="physicalAddressprogressValue"
              ></dx-progress-bar>
            </div>
            <dx-file-uploader
               #physicalAddress_fileUploader
               id="physicalAddress-fileSelector"
               [multiple]="true"
               [visible]="false"
               [uploadCustomData]="{ KeyCloakUserId:usrKeyCloakId, MerchantId : merchantId, DocumentType: documentTypes.PhysicalAddressConfirmationViaUtilityBill}"
               uploadMode="instantly"
               uploadUrl="{{FileUploadUrl}}"
               (onDropZoneEnter)="onDropZoneEnter($event)"
               (onDropZoneLeave)="onDropZoneLeave($event)"
               (onUploaded)="onUploaded($event)"
               (onProgress)="onProgress($event)"
               (onUploadStarted)="onUploadStarted($event)">
            </dx-file-uploader>
          </dxi-item>
        </dx-box>


      </dxi-item>

      <dxi-item [ratio]="2" [baseSize]="0">
        
        <!-- Bank Confirmation Letter -->
        <dx-box direction="row" width="75%" [height]="125">
          <dxi-item class="rect demo-dark" [baseSize]="30"> 
            <dx-check-box
            [(value)]="individualBankConfirmationLetter_checkBoxValue"
            hint="File has been Uploaded"></dx-check-box>
          </dxi-item>
          <dxi-item class="rect demo-light" [baseSize]="210"><div><small>Bank Confirmation Letter</small></div>  </dxi-item>
          <dxi-item class="rect demo-dark" [baseSize]="350">
            
            <div #individualBankConfirmationLetter_dropzone_external id="individualBankConfirmation-UploadArea" class="flex-box uploadArea" [ngClass]="isindividualBankConfirmationLetterDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']">
                <img id="individualBankConfirmation-dropzone-image" class="Dropzone-Image" [src]="individualBankConfirmationLetterimageSource" *ngIf="individualBankConfirmationLetterimageSource" alt="" />
                <div id="individualBankConfirmation-dropzone-text" class="flex-box uploadArea" *ngIf="individualBankConfirmationLettertextVisible">
                  <span>upload</span>
                  <!-- <span>…or click to browse for a file instead.</span> -->
                </div>
              <dx-progress-bar
                #individualBankConfirmationLetter_uploadProgress
                [min]="0"
                [max]="100"
                width="100%"
                [showStatus]="true"
                [statusFormat]="statusFormat"
                [visible]="individualBankConfirmationLetterprogressVisible"
                [value]="individualBankConfirmationLetterprogressValue"
              ></dx-progress-bar>
            </div>
            <dx-file-uploader
               #individualBankConfirmationLetter_fileUploader
               id="individualBankConfirmation-fileSelector"
               [multiple]="true"
               [visible]="false"
               [uploadCustomData]="{ KeyCloakUserId:usrKeyCloakId, MerchantId : merchantId, DocumentType: documentTypes.BankConfirmationLetter}"
               uploadMode="instantly"
               uploadUrl="{{FileUploadUrl}}"
               (onDropZoneEnter)="onDropZoneEnter($event)"
               (onDropZoneLeave)="onDropZoneLeave($event)"
               (onUploaded)="onUploaded($event)"
               (onProgress)="onProgress($event)"
               (onUploadStarted)="onUploadStarted($event)">
            </dx-file-uploader>
          </dxi-item>
        </dx-box>
      </dxi-item>
    </dx-box>

    <dx-box direction="col" width="100%"  [height]="70">
      <dxi-item class="rect demo-dark header" [ratio]="1" height="100" style="font-weight: bold;"> Company Documents </dxi-item>
      <dxi-item [ratio]="2" [baseSize]="0">
        <!-- Company Documents -->
        <dx-box direction="row" width="100%" [width]="500">
          <dxi-item class="rect demo-dark" [baseSize]="30"> 
            <dx-check-box 
            [(value)]="companyRegistration_checkBoxValue"
            hint="File has been Uploaded"></dx-check-box>
          </dxi-item>
          <dxi-item id="CompanyRegistrationHeader" class="rect demo-light"[baseSize]="210" ><div><small>Company Registration Documents</small></div></dxi-item>
          <dxi-item class="rect demo-dark" [baseSize]="125">
            
            <div #companyRegistration_dropzone_external id="companyRegistration-UploadArea" class="flex-box uploadArea" [ngClass]="iscompanyRegistrationDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']">
                <img id="companyRegistration-dropzone-image" class="Dropzone-Image" [src]="companyRegistrationimageSource" *ngIf="companyRegistrationimageSource" alt="" />
                <div id="companyRegistration-dropzone-text" class="flex-box uploadArea" *ngIf="companyRegistrationtextVisible">
                  <span>upload</span>
                  <!-- <span>…or click to browse for a file instead.</span> -->
                </div>
              <dx-progress-bar
                #companyRegistration_uploadProgress
                [min]="0"
                [max]="100"
                width="100%"
                [showStatus]="true"
                [statusFormat]="statusFormat"
                [visible]="companyRegistrationprogressVisible"
                [value]="companyRegistrationprogressValue"
              ></dx-progress-bar>
            </div>
            <dx-file-uploader
                #companyRegistration_fileUploader
               id="companyRegistration-fileSelector"
               [uploadCustomData]="{ KeyCloakUserId:usrKeyCloakId, MerchantId : merchantId, DocumentType: documentTypes.CompanyRegistrationDocuments}"
               uploadMode="instantly"
               uploadUrl="{{FileUploadUrl}}"
               [multiple]="true"
               [visible]="false"
               (onDropZoneEnter)="onDropZoneEnter($event)"
               (onDropZoneLeave)="onDropZoneLeave($event)"
               (onUploaded)="onUploaded($event)"
               (onProgress)="onProgress($event)"
               (onUploadStarted)="onUploadStarted($event)">
            </dx-file-uploader>
          </dxi-item>
        </dx-box>
      </dxi-item>
    </dx-box>

    <dx-box direction="row" [height]="50">
      <!-- Reflectig latest director changes * -->
      <dxi-item ratio="2" class="rect demo-light" style="background-color: white;border-radius: 4px;" [baseSize]="300"> 
        *Reflecting latest director changes i.e Registered Private / Public Company: COR 14.3 Registration Certificate 
      </dxi-item>
   </dx-box>
   

   <dx-box direction="col" width="100%"  [height]="125">
    <dxi-item [ratio]="2" [baseSize]="0">
      <!-- Physical Address Upload Area -->
      <dx-box direction="row" width="75%" [height]="125">
        <dxi-item class="rect demo-dark" [baseSize]="30"> 
          <dx-check-box
           [(value)]="vatClearance_checkBoxValue"
           hint="File has been Uploaded"></dx-check-box>
        </dxi-item>
        <dxi-item class="rect demo-light" [baseSize]="210"> <div><small>VAT Clearance Certificate</small></div> </dxi-item>
        <dxi-item class="rect demo-dark" [baseSize]="125">
          
          <div #vatClearance_dropzone_external id="vatClearance-UploadArea" class="flex-box uploadArea" [ngClass]="isvatClearancefileDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']">
              <img id="vatClearance-dropzone-image" class="Dropzone-Image" [src]="vatClearancefileimageSource" *ngIf="vatClearancefileimageSource" alt="" />
              <div id="vatClearance-dropzone-text" class="flex-box uploadArea" *ngIf="vatClearancefiletextVisible">
                <span>upload</span>
              </div>
              <dx-progress-bar
                #vatClearance_uploadProgress
                [min]="0"
                [max]="100"
                width="100%"
                [showStatus]="true"
                [statusFormat]="statusFormat"
                [visible]="vatClearancefileprogressVisible"
                [value]="vatClearancefileprogressValue"
              ></dx-progress-bar>
            </div>
            <dx-file-uploader
              #vatClearance_fileUploader
              id="vatClearance-fileSelector"
              [uploadCustomData]="{ KeyCloakUserId:usrKeyCloakId, MerchantId : merchantId, DocumentType: documentTypes.VatClearanceCertificate}"
               uploadMode="instantly"
               uploadUrl="{{FileUploadUrl}}"
              [multiple]="true"
              [visible]="false"
              (onDropZoneEnter)="onDropZoneEnter($event)"
               (onDropZoneLeave)="onDropZoneLeave($event)"
               (onUploaded)="onUploaded($event)"
               (onProgress)="onProgress($event)"
               (onUploadStarted)="onUploadStarted($event)">
            </dx-file-uploader>
        </dxi-item>
      </dx-box>
    </dxi-item>

    <dxi-item [ratio]="2" [baseSize]="0">
      <!-- Physical Address Confirmation via Utility Bill -->
      <dx-box direction="row" width="75%" [height]="125">
        <dxi-item class="rect demo-dark" [baseSize]="30"> 
          <dx-check-box
          [(value)]="companyPhysicalAddress_checkBoxValue"
           hint="File has been Uploaded"></dx-check-box>
        </dxi-item>
        <dxi-item class="rect demo-light" [baseSize]="210"><div><small>Physical Address Confirmation via Utility Bill / Statement</small></div> </dxi-item>
        <dxi-item class="rect demo-dark" [baseSize]="125">
          
          <div #companyPhysicalAddress_dropzone_external id="companyPhysicalAddress-UploadArea" class="flex-box uploadArea" [ngClass]="iscompanyPhysicalAddressDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']">
              <img id="companyPhysicalAddress-dropzone-image" class="Dropzone-Image" [src]="companyPhysicalAddressimageSource" *ngIf="companyPhysicalAddressimageSource" alt="" />
              <div id="companyPhysicalAddress-dropzone-text" class="flex-box uploadArea" *ngIf="companyPhysicalAddresstextVisible">
                <span>upload</span>
                
              </div>
              <dx-progress-bar
                #companyPhysicalAddress_uploadProgress
                [min]="0"
                [max]="100"
                width="100%"
                [showStatus]="true"
                [statusFormat]="statusFormat"
                [visible]="companyPhysicalAddressprogressVisible"
                [value]="companyPhysicalAddressprogressValue"
              ></dx-progress-bar>
            </div>
            <dx-file-uploader
              #companyPhysicalAddress_fileUploader
              id="companyPhysicalAddress-fileSelector"
              [uploadCustomData]="{ KeyCloakUserId:usrKeyCloakId, MerchantId : merchantId, DocumentType: documentTypes.PhysicalAddressConfirmationViaUtilityBill}"
               uploadMode="instantly"
               uploadUrl="{{FileUploadUrl}}"
              [multiple]="true"
              [visible]="false"
              (onDropZoneEnter)="onDropZoneEnter($event)"
               (onDropZoneLeave)="onDropZoneLeave($event)"
               (onUploaded)="onUploaded($event)"
               (onProgress)="onProgress($event)"
               (onUploadStarted)="onUploadStarted($event)">
            </dx-file-uploader>
        </dxi-item>
      </dx-box>
    </dxi-item>

    <dxi-item [ratio]="2" [baseSize]="0">
      <!-- Company Bank Confirmation Letter -->
      <dx-box direction="row" width="75%" [height]="125">
        <dxi-item class="rect demo-dark" [baseSize]="30"> 
          <dx-check-box
          [(value)]="companybankConfirmationLetter_checkBoxValue"
          hint="File has been Uploaded"></dx-check-box>
        </dxi-item>
        <dxi-item class="rect demo-light" [baseSize]="210"><div><small>Bank Confirmation Letter</small></div></dxi-item>
        <dxi-item class="rect demo-dark" [baseSize]="125">
          
          <div #companybankConfirmationLetter_dropzone_external id="companybankConfirmationLetter-UploadArea" class="flex-box uploadArea" [ngClass]="iscompanybankConfirmationLetterDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']">
              <img id="companybankConfirmationLetter-dropzone-image" class="Dropzone-Image" [src]="companybankConfirmationLetterimageSource" *ngIf="companybankConfirmationLetterimageSource" alt="" />
              <div id="companybankConfirmationLetter-dropzone-text" class="flex-box uploadArea" *ngIf="companybankConfirmationLettertextVisible">
                <span>upload</span>
                
              </div>
              <dx-progress-bar
                #companybankConfirmationLetter_uploadProgress
                [min]="0"
                [max]="100"
                width="100%"
                [showStatus]="true"
                [statusFormat]="statusFormat"
                [visible]="companybankConfirmationLetterprogressVisible"
                [value]="companybankConfirmationLetterprogressValue"
              ></dx-progress-bar>
            </div>
            <dx-file-uploader
              #companybankConfirmationLetter_fileUploader
              id="companybankConfirmationLetter-fileSelector"
              [uploadCustomData]="{ KeyCloakUserId:usrKeyCloakId, MerchantId : merchantId, DocumentType: documentTypes.CompanyBankConfirmationLetter}"
               uploadMode="instantly"
               uploadUrl="{{FileUploadUrl}}"
              [multiple]="true"
              [visible]="false"
              (onDropZoneEnter)="onDropZoneEnter($event)"
               (onDropZoneLeave)="onDropZoneLeave($event)"
               (onUploaded)="onUploaded($event)"
               (onProgress)="onProgress($event)"
               (onUploadStarted)="onUploadStarted($event)">
            </dx-file-uploader>
        </dxi-item>
      </dx-box>
    </dxi-item>
  </dx-box>
</form>
  </div>
</div>